import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export default function QRCodeComponent({ url }) {
  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <QRCodeCanvas value={url} size={256} />
      <div style={{ marginTop: '10px', wordBreak: 'break-all', fontSize: '0.9em', color: '#333' }}>{url}</div>
    </div>
  );
}
